import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resolvePageSeo } from '@/seo/config';
import { applySeo } from '@/seo/meta';
import { setJsonLd } from '@/seo/schema';

export default function SeoManager() {
  const location = useLocation();

  useEffect(() => {
    const page = resolvePageSeo(location.pathname);
    if (page) {
      applySeo(page.seo);
      setJsonLd('page-jsonld', page.jsonLd);
    } else {
      setJsonLd('page-jsonld', null);
    }
  }, [location.pathname]);

  return null;
}